/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AnatomyViewRotationType {
  Back = 'Back',
  Right = 'Right',
  Front = 'Front',
  Left = 'Left'
}
